/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Consumption_Remove_SeriesInputs */



/**
* | output |
* | --- |
* | "Remove {name}" |
*
* @param {Consumption_Remove_SeriesInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const consumption_remove_series = /** @type {((inputs: Consumption_Remove_SeriesInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Consumption_Remove_SeriesInputs, { locale?: "fr" | "en" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ (`Remove ${i?.name}`)
	return /** @type {LocalizedString} */ (`Retirer ${i?.name}`)
});